// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const AccountBalance = React.forwardRef(function AccountBalance(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"/></SvgIcon>;
});
export default AccountBalance;
